import { PhoneIcon, MailIcon } from '@heroicons/react/outline'

import { businessInfo } from '../../data/site'

import './index.css'

export const TopBar = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-4 bg-primary-900 text-primary-100 text-xs sm:text-sm px-4 sm:px-8 py-2">
      <div className="flex items-center gap-1.5">
        <PhoneIcon className="h-4 w-4 text-accent-300 shrink-0" />
        <span>{businessInfo.phones.join(' | ')}</span>
      </div>
      <div className="flex items-center gap-1.5">
        <MailIcon className="h-4 w-4 text-accent-300 shrink-0" />
        <span>{businessInfo.email}</span>
      </div>
    </div>
  )
}
